import { z } from "zod"

export const CENTRA_MARKET_CODE = {
    Jp: "jp",
    Eu: "eu",
    Na: "na",
    Apac: "apac"
} as const

export type CentraMarketCode =
    (typeof CENTRA_MARKET_CODE)[keyof typeof CENTRA_MARKET_CODE]

export const MarketCodeSchema = z.enum(
    Object.values(CENTRA_MARKET_CODE) as [CentraMarketCode, ...CentraMarketCode[]]
)

export const validateMarketCode = (code: string) => MarketCodeSchema.safeParse(code)
